import { useMediaQuery, useTheme } from '@mui/material';

const VALID_BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];

const useCommonMediaQuery = breakpoint => {
  const theme = useTheme();
  const safeBreakpoint = VALID_BREAKPOINTS.includes(breakpoint)
    ? breakpoint
    : 'md';

  return useMediaQuery(theme.breakpoints.down(safeBreakpoint));
};

export default useCommonMediaQuery;
